import { DataPanelInlineItem } from './DataPanelInlineItem';
import { DataPanelItem } from './DataPanelItem';
import type { DataPanelItemBaseProps } from './dataPanelItemBase';

export type DataPanelAutoWrapInlineItemProps = DataPanelItemBaseProps;

const AUTO_WRAP_THRESHOLD = 50;

export function DataPanelAutoWrapInlineItem(props: DataPanelAutoWrapInlineItemProps) {
  const { value } = props;

  const wrapCondition =
    (value != null && value.length > AUTO_WRAP_THRESHOLD) || value?.includes('\n') === true;

  return wrapCondition ? <DataPanelItem {...props} /> : <DataPanelInlineItem {...props} />;
}
